import React, {useEffect} from 'react';
import {Header, Button, Dimmer, Loader} from 'semantic-ui-react';
import {useSelector} from 'react-redux';
import { Link } from 'react-router-dom';

import './styles.css';
import AddressCard from '../../components/AddressCard';
import CardSummary from '../../components/CardSummary/CardSummary';
import CheckoutSteps, { CHECKOUT_STEP_SHIPPING } from '../../components/CheckoutSteps';
import {getTotalPrice, hasOnlyVirtuals} from '../Cart/reducer';
import {getAddressFields, getIsJuridic, hasFormErrors} from "../../components/AddressCard/reducer";
import {getFormDataForAPI} from "../../components/AddressCard/actions";
import ShippingCard from "../../components/ShippingCard";
import ConfirmOrderButton from "../../components/ConfirmOrderButton";
import {getPlaceOrderInProgress} from "../Orders/reducer";
import {checkoutOrderPlaced} from "../Orders/actions";

export default function CheckoutStepShipping(props) {

    const {dispatch, userLocation, userData, mixpanel} = props;

    const total_products = useSelector((state) => getTotalPrice(state.cart));
    const only_virtuals = useSelector((state) => hasOnlyVirtuals(state.cart));
    const total_price = useSelector((state) => getTotalPrice(state.cart));
    const addressFields = useSelector((state) => getAddressFields(state.address));
    const isJuridic = useSelector((state) => getIsJuridic(state.address));
    const formHasErrors = useSelector((state) => hasFormErrors(state.address));
    const getLoading = useSelector((state) => getPlaceOrderInProgress(state.orders));

    useEffect(() => {
        if (mixpanel) {
            // Подготавливаем данные для аналитики
            const analyticsData = {
                ...userLocation,
                ...userData,
                entity_type: isJuridic ? 'juridic' : 'individual',
                has_company: !!addressFields.companyName,
                has_website: !!addressFields.website,
                country: addressFields.countryCode,
                // Не отправляем персональные данные в аналитику
                form_filled_percentage: calculateFormCompletion(addressFields, isJuridic)
            };

            mixpanel.track('Checkout Address', analyticsData);
        }

        window.scrollTo(0, 0);
        dispatch(checkoutOrderPlaced({})); // сбрасываем зависшие сессии по созданию заказа
    }, []);

    // Функция для расчета процента заполнения формы
    const calculateFormCompletion = (fields, isJuridic) => {
        const requiredFields = [
            'firstName', 'lastName', 'phone', 'countryCode', 'stateCode', 'cityName'
        ];

        if (isJuridic) {
            requiredFields.push('companyName');
        }

        const filledFields = requiredFields.filter(field => fields[field]?.trim());
        return Math.round((filledFields.length / requiredFields.length) * 100);
    };

    // Функция для получения текста кнопки в зависимости от типа лица
    const getButtonText = () => {
        if (total_price) {
            return isJuridic ? "К выбору способа оплаты" : "К выбору способа оплаты";
        }
        return isJuridic ? "Подтвердить заказ (юр. лицо)" : "Подтвердить заказ";
    };

    // Функция для проверки готовности формы
    const isFormReady = () => {
        return !addressFields.hasErrors && !formHasErrors;
    };

    const button_text = getButtonText();

    return (
        <div>
            <Header textAlign="center">Оформление заказа</Header>
            <CheckoutSteps step={CHECKOUT_STEP_SHIPPING} />

            <Dimmer active={ getLoading === 1 } inverted>
                <Loader inverted>Создаем заказ...</Loader>
            </Dimmer>

            {/* Основная форма */}
            <AddressCard {...props}/>

            { !only_virtuals ? <ShippingCard /> : '' }

            {/*<CardSummary total_products={total_products} />*/}

            {/* Кнопки навигации */}
            <div className="checkout-buttons-container" style={{textAlign: 'center', marginTop: '20px'}}>
                { !isFormReady()
                    ? (
                        <Button
                            className="checkout-address-buttons-button disabled"
                            color="green"
                            disabled={true}
                            size="large"
                        >
                            {button_text}
                        </Button>
                    )
                    : (total_price
                            ? (
                                <Link to="/checkout-step-payment">
                                    <Button
                                        className="checkout-address-buttons-button goto-payment-options"
                                        color="green"
                                        size="large"
                                    >
                                        {button_text}
                                    </Button>
                                </Link>
                            )
                            : (
                                <ConfirmOrderButton
                                    addClassName="checkout-address-buttons-button"
                                    buttonText={button_text}
                                    pathToRoute="/checkout-step-confirm"
                                    entityType={isJuridic ? 'juridic' : 'individual'}
                                    size="large"
                                    {...props}
                                />
                            )
                    )
                }

                {/* Дополнительная информация для пользователя */}
                {!isFormReady() && (
                    <div style={{
                        marginTop: '10px',
                        fontSize: '12px',
                        color: '#dc3545',
                        maxWidth: '400px',
                        margin: '10px auto 0'
                    }}>
                        {isJuridic
                            ? 'Заполните все обязательные поля: название организации, ИНН, контактные данные и адрес'
                            : 'Заполните все обязательные поля: имя, фамилию, контактные данные и адрес'
                        }
                    </div>
                )}
            </div>
        </div>
    );
}